import type { UntypedFunction } from '@mnd-frontend/ts';
import { Button, Pagination } from '@mnd-frontend/ui/publish/components';
import { media } from '@mnd-frontend/ui/publish/utils';
import { SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  totalPages?: number;
  currentPage?: number;
  onChangePage?: UntypedFunction;
  onDismiss: () => void;
  children?: ReactNode;
}

const FooterWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.lessThan('tablet')} {
    align-items: flex-end;
  }
`;

const PaginationWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: ${SPACING_3};
  align-items: center;
  ${media.lessThan('tablet')} {
    flex-wrap: wrap-reverse;
  }
`;

const Footer = ({
  totalPages = 0,
  currentPage = 0,
  onChangePage = () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  onDismiss,
  children,
}: Props) => {
  const [t] = useTranslation();

  return (
    <FooterWrapper>
      <PaginationWrapper>
        {totalPages > 1 && currentPage && (
          <div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onChangePage={onChangePage}
            />
          </div>
        )}
        {children}
      </PaginationWrapper>
      <Button type="button" onClick={onDismiss} data-testid="modal-footer-done-btn">
        {t('common_accept')}
      </Button>
    </FooterWrapper>
  );
};

export default Footer;
